import { z } from 'zod';

// Built per-selected-plan (like the old buildSubscriptionSchema pattern)
// so the principal bounds always match whichever plan is currently chosen
// in the form — re-created via useMemo keyed on the plan, not a static
// export. The plan's min/max are a client-side nicety only; the server's
// 422 on `principal` is still the real source of truth.
export function buildCreateInvestmentSchema(plan) {
  const min = plan ? Number(plan.minimum_amount) : null;
  const max = plan?.maximum_amount != null ? Number(plan.maximum_amount) : null;

  return z.object({
    investment_plan_uuid: z.string().min(1, 'Select a plan'),
    principal: z.coerce
      .number({ invalid_type_error: 'Enter an amount' })
      .positive('Enter an amount greater than 0')
      .refine((v) => min == null || v >= min, () => ({ message: `Minimum for this plan is ${min?.toLocaleString()}` }))
      .refine((v) => max == null || v <= max, () => ({ message: `Maximum for this plan is ${max?.toLocaleString()}` })),
    // Both optional and independent — an empty string means "use the
    // plan's default," not 0. Sending 0 explicitly would flip
    // is_override: true server-side, which isn't what an untouched field
    // means.
    custom_roi_percentage: z
      .union([z.literal('').transform(() => undefined), z.coerce.number().min(0, 'ROI % must be 0 or more')])
      .optional(),
    custom_duration_in_days: z
      .union([z.literal('').transform(() => undefined), z.coerce.number().int('Must be a whole number of days').positive('Must be greater than 0')])
      .optional(),
  });
}
